import { BaseModel } from '..';
import { FabricationMethod } from 'app/core/enums';

export class TreatmentExtraMetadataModel {
  treatmentPlan: string = '';
  primarySet?: number;
  backupSet?: number;
  unfinishedSet?: number;
  nightGuardSet?: number;
  reprintCount?: number;
  upgradeToNeerCount?: number;
  redesignCount?: number;
  currentAction?: string;
  userComment?: string;
}
